import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

const Nav = ({ content }) => {
    return (
        <div className={styles.navBox}>
            <div className={styles.nav}>
                <div className={styles.item1}>
                    <div className={styles.itemTitle}>{content.focusName}</div>
                    <div className={styles.sNavList}>
                        {content.focusList.map((item, index) => {
                            return (
                                <a key={index} href={item.url} target="_blank" className={styles.sNavLista}>
                                    {item.name}
                                </a>
                            );
                        })}
                    </div>
                </div>
                <div className={styles.item2}>
                    <div className={styles.itemTitle}>{content.originalName}</div>
                    <div className={styles.sNavList}>
                        {content.originalList.map((item, index) => {
                            return (
                                <a key={index} href={item.url} target="_blank" className={styles.sNavLista}>
                                    {item.name}
                                </a>
                            );
                        })}
                    </div>
                </div>
                <div className={styles.item3}>
                    <div className={styles.itemTitle}>{content.wikiName}</div>
                    <div className={styles.sNavList}>
                        {content.wikiList.map((item, index) => {
                            return (
                                <a key={index} href={item.url} target="_blank" className={styles.sNavLista}>
                                    {item.name}
                                </a>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
};

Nav.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Nav);
